export const STORY_DURATION_MS = 5200;
